import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";
import { CITIES, SERVICE_PAGES } from "./seoData";
import { Eyebrow, Reveal } from "./Reveal";

export const ServiceLinks = ({ exclude, dark = false }) => (
  <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
    {SERVICE_PAGES.filter((s) => s.slug !== exclude).map((s) => (
      <Link
        key={s.slug}
        to={`/services/${s.slug}`}
        data-testid={`service-link-${s.slug}`}
        className={`group flex items-center justify-between gap-3 rounded-2xl border px-5 py-4 font-bold transition-colors ${dark ? "border-white/15 text-[#F2EEE6] hover:border-[#FFB000] hover:text-[#FFB000]" : "border-[#0D0D0B]/15 bg-white text-[#0D0D0B] hover:border-[#0D0D0B]"}`}
      >
        <span className="flex items-center gap-3"><s.icon className={`h-5 w-5 ${dark ? "text-[#FFB000]" : "text-[#8A5A00]"}`} />{s.name}</span>
        <ArrowUpRight className="h-4 w-4 shrink-0 transition-transform group-hover:rotate-45" />
      </Link>
    ))}
  </div>
);

export const CityLinks = ({ exclude }) => (
  <div className="flex flex-wrap gap-3">
    {CITIES.filter((c) => c.slug !== exclude).map((c, i) => (
      <Link
        key={c.slug}
        to={`/junk-removal/${c.slug}`}
        data-testid="service-area-city-tag"
        className={`flex items-center gap-2 rounded-full px-5 py-3 text-base font-bold transition-transform hover:-translate-y-0.5 ${i === 0 && !exclude ? "bg-[#FFB000] text-[#0D0D0B]" : "border border-white/20 text-[#F2EEE6] hover:border-[#FFB000]"}`}
      >
        <MapPin className="h-4 w-4" strokeWidth={2.5} />{c.name}, SC
      </Link>
    ))}
  </div>
);

export const AllServices = () => (
  <section data-testid="all-services-section" className="bg-[#F2EEE6] pb-24 sm:pb-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <div className="grid gap-10 border-t-2 border-[#0D0D0B] pt-12 lg:grid-cols-12">
        <Reveal className="lg:col-span-4">
          <Eyebrow dark>Every service</Eyebrow>
          <h2 className="font-display mt-4 text-5xl uppercase leading-[0.9] text-[#0D0D0B] sm:text-6xl">Residential & commercial junk removal</h2>
          <p className="mt-5 text-base text-[#3a3a35]">Cazares Junk Removal is a local junk removal company in Greenville, SC. Homeowners, landlords, contractors and businesses call us for affordable, same-day junk hauling with a free onsite quote and upfront pricing.</p>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-8">
          <ServiceLinks />
        </Reveal>
      </div>
    </div>
  </section>
);
